import { render, staticRenderFns } from "./ClientsSection.vue?vue&type=template&id=670059d8&scoped=true&"
import script from "./ClientsSection.vue?vue&type=script&lang=js&"
export * from "./ClientsSection.vue?vue&type=script&lang=js&"
import style0 from "./ClientsSection.vue?vue&type=style&index=0&id=670059d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670059d8",
  null
  
)

export default component.exports